/**
 * Anontools component.
 * @module components/theme/Anontools/Anontools
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';
import jwtDecode from 'jwt-decode';
import { getUser } from '@plone/volto/actions';
import config from '@plone/volto/registry';

import noprofilePNG from 'volto-proseriestools/icons/noprofile.png';

/**
 * Anontools container class.
 */
export class Anontools extends Component {
  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs DiffComponent
   */
  constructor(props) {
    super(props);
    this.onGetStarted = this.onGetStarted.bind(this);
  }

  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    token: PropTypes.string,
    content: PropTypes.shape({
      '@id': PropTypes.string,
    }),
  };

  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    token: null,
    content: {
      '@id': null,
    },
  };

  componentDidMount() {
    if (this.props.token) {
      this.props.getUser(this.props.userId);
    }
  }

  /**
   * Component will receive props
   * @method componentWillReceiveProps
   * @param {Object} nextProps Next properties
   * @returns {undefined}
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.token && !nextProps.user) {
      nextProps.getUser(this.props.userId);
    }
  }

  /**
   * On get started
   * @method onGetStarted
   * @param {object} event Event object
   * @returns {undefined}
   */
  onGetStarted() {
    this.props.history.push('/plans');
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    const { settings } = config;
    return this.props.token ? (
      <Menu secondary floated="right" className="authenticated">
        <Dropdown
          item
          direction="left"
          trigger={
            <div className="avatar">
              {this.props.user.portrait ? (
                <img
                  src={flattenToAppURL(this.props.user.portrait)}
                  alt={this.props.intl.formatMessage(messages.userAvatar)}
                />
              ) : (
                <img src={noprofilePNG} width="30" height="30" alt="profile" />
              )}
            </div>
          }
        >
          <Dropdown.Menu>
            <Dropdown.Header>Account</Dropdown.Header>
            <Dropdown.Item disabled className="userinfo">
              <div className="portrait">
                {this.props.user.portrait ? (
                  <img
                    src={flattenToAppURL(this.props.user.portrait)}
                    alt={this.props.intl.formatMessage(messages.userAvatar)}
                  />
                ) : (
                  <img
                    src={noprofilePNG}
                    width="30"
                    height="30"
                    alt="profile"
                  />
                )}
              </div>
              <div>
                <div className="fullname">{this.props.user.fullname}</div>
                <div className="email">{this.props.user.email}</div>
              </div>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Header>Gravity</Dropdown.Header>
            <Dropdown.Item>
              <Link to={`/users/${this.props.userId}`}>My profile</Link>
            </Dropdown.Item>
            <Dropdown.Item>
              <Link to={`/users/${this.props.userId}/intakes/intake`}>
                Intake
              </Link>
            </Dropdown.Item>
            <Dropdown.Item>
              <Link to={`/users/${this.props.userId}/trainingplans`}>
                Training plan
              </Link>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item>
              <Link to={`/logout`}>Log out</Link>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu>
    ) : (
      <Menu secondary floated="right" className="anonymous">
        <Menu.Item>
          <Link
            aria-label="login"
            to={`/login${
              this.props.content?.['@id']
                ? `?return_url=${this.props.content['@id'].replace(
                    settings.apiPath,
                    '',
                  )}`
                : ''
            }`}
          >
            <FormattedMessage id="Log in" defaultMessage="Log in" />
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Button
            primary
            className="rounded"
            size="small"
            onClick={this.onGetStarted}
          >
            <FormattedMessage
              id="Get Started! in"
              defaultMessage="Get Started!"
            />
          </Button>
        </Menu.Item>
      </Menu>
    );
  }
}

export default compose(
  injectIntl,
  withRouter,
  connect(
    (state) => ({
      token: state.userSession.token,
      content: state.content.data,
      user: state.users.user,
      userId: state.userSession.token
        ? jwtDecode(state.userSession.token).sub
        : '',
    }),
    { getUser },
  ),
)(Anontools);
